import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { emailTemplateEndpoints } from '@/lib/api/endpoints';
import { emailTemplateKeys } from '@/lib/queryKeys';
import type { EmailTemplateKind, EmailTemplateSummary } from '@/types/emailTemplate';

/** Lists the tenant's email templates (summaries — no body), by kind. */
export function useEmailTemplates(params: { kind?: EmailTemplateKind } = {}) {
  const { kind } = params;
  return useApiQuery<EmailTemplateSummary[]>({
    queryKey: emailTemplateKeys.list({ kind }),
    queryFn: () =>
      apiGet<EmailTemplateSummary[]>(operationsClient, emailTemplateEndpoints.list({ kind })),
  });
}
